import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import reportGroupServices from "../services/reportGroupServices";

export const useFetchReportGroupSummary = (groupId) => {
  return useQuery({
    queryKey: ["reportGroupSummary", groupId],
    queryFn: () => reportGroupServices.FetchReportGroupSummary(groupId),
    enabled: !!groupId,
    staleTime: 1 * 60 * 1000,
  });
};

// Merged trend line for the Overview's Dashboard sub-tab — same staleTime as
// useFetchReportSnapshots (single report) in useFetchReport.js.
export const useFetchReportGroupSnapshots = (groupId) => {
  return useQuery({
    queryKey: ["reportGroupSnapshots", groupId],
    queryFn: () => reportGroupServices.FetchReportGroupSnapshots(groupId),
    enabled: !!groupId,
    staleTime: 5 * 60 * 1000,
  });
};

export const useAttachReportToGroup = (groupId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ reportId }) => reportGroupServices.AttachReportToGroup(groupId, reportId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reportGroupSummary", groupId] });
      queryClient.invalidateQueries({ queryKey: ["fetchReportGroups"] });
      queryClient.invalidateQueries({ queryKey: ["fetchReports"] });
    },
    onError: (error) => {
      console.error("Error attaching report to group:", error);
      throw error;
    },
  });
};

export const useDetachReportFromGroup = (groupId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ reportId }) => reportGroupServices.DetachReportFromGroup(groupId, reportId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reportGroupSummary", groupId] });
      queryClient.invalidateQueries({ queryKey: ["fetchReportGroups"] });
      queryClient.invalidateQueries({ queryKey: ["fetchReports"] });
    },
    onError: (error) => {
      console.error("Error detaching report from group:", error);
      throw error;
    },
  });
};

export default { useFetchReportGroupSummary, useFetchReportGroupSnapshots, useAttachReportToGroup, useDetachReportFromGroup };
